import { z } from 'zod';

const identityFileSchema = z.instanceof(File).nullable().optional();

const accountCopyFileSchema = z.instanceof(File).nullable().optional();

const businessLicenseFileSchema = z.instanceof(File).nullable().optional();

export const settlementFormSchema = z.object({
  businessType: z.enum(['NATURAL_PERSON', 'SOLO_PROPRIETORSHIP', 'LEGAL_ENTITY']),
  idNumberFirst: z.string().optional(),
  idNumberSecond: z.string().optional(),
  identityFile: identityFileSchema,
  businessName: z.string().optional(),
  businessRegistrationNumber: z.string().optional(),
  businessLicenseFile: businessLicenseFileSchema,
  bankName: z.string().optional(),
  accountNumber: z.string().optional(),
  accountHolder: z.string().optional(),
  isAccountVerified: z.boolean(),
  accountCopyFile: accountCopyFileSchema,
  termsAgreed: z.boolean().refine((val) => val === true, '정산 정보 수집 이용 동의를 해주세요.'),
});

export type SettlementFormData = z.infer<typeof settlementFormSchema>;

export type BusinessType = 'NATURAL_PERSON' | 'SOLO_PROPRIETORSHIP' | 'LEGAL_ENTITY';
